import serialize from 'serialize-javascript';
import paths from '../../../routes/paths';
import { loggedIn, itemsInBasket } from '../../../routes/conditional';
import {
  getCCPharmacySelected,
  getNewOrderItems,
  getSchedulingSelectedOrderDate,
  getUserDeliveryAddress,
} from '../../../redux/modules/root-reducer';
import {
  removeOrderItem,
  clearCreateError,
  createOrder as createOrderAction,
  clearSelectedCCPharmacy,
} from '../../../redux/modules/neworder';
import { fetchDeliveryAddress } from '../../../redux/modules/user';

export const page = {
  path: paths.createOrder.summary,
  isAllowed: [loggedIn, itemsInBasket],
  action: () => fetchDeliveryAddress(),
};

const REMOVE_MED_ACTION_PATH = '/actions/create-order/summary/remove-medicine';
export const removeMedicine = {
  actionPath: REMOVE_MED_ACTION_PATH,
  action: ({ query, state }) => {
    const idx = parseInt(query.index);
    const isLastItem = getNewOrderItems(state).length === 1;
    return removeOrderItem(idx, isLastItem);
  },
  buildFormActionPath: (i) => `${REMOVE_MED_ACTION_PATH}?index=${i}`,
};

export const createOrder = {
  actionPath: '/actions/create-order/summary/create-order',
  medicineInput: 'medicine',
  notesInput: 'notes',
  mapMedicineToInput: (m) => serialize(m),
  action: ({ body, state }) => {
    const rawMedicines = Array.isArray(body.medicine)
      ? body.medicine
      : [body.medicine];
    const medicines = rawMedicines.map((m) => JSON.parse(m));
    const dueDate = getSchedulingSelectedOrderDate(state);
    const ccPharmacySelected = getCCPharmacySelected(state);
    const deliveryAddress = getUserDeliveryAddress(state);
    return createOrderAction(
      medicines,
      body.notes,
      dueDate,
      ccPharmacySelected,
      deliveryAddress
    );
  },
};

export const clearError = {
  actionPath: '/actions/create-order/summary/clear-error',
  action: () => clearCreateError(),
};

export const changeDeliveryPreference = {
  actionPath: '/actions/create-order/summary/change-delivery-preference',
  action: () => clearSelectedCCPharmacy(),
};
